import { IDiagnosticableObject } from '../../../contracts/diagnosticable-object.js';
import { DataModel } from '../../dto/dto.js';

export abstract class CalendarSnapshot extends DataModel implements IDiagnosticableObject {
  static readonly GLOBAL_STATE_ID: string = '_CALENDAR_GLOBAL_STATE';

  abstract toDiagnosticsObject(): unknown;
}
